<div class="top-bar" [ngClass]="{'login-route': isLoginRoute()}">
    <div class="title-bar">
        <h2>{{ title }}</h2>
    </div>
    <div class="login-bar">

          <button mat-button [matMenuTriggerFor]="menu" class="login-button">
            <span>{{ userLogin || 'Not logged in' }}</span>&nbsp;
            <mat-icon svgIcon="account-circle"></mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <ng-container *ngIf="(authenticated | async); else notLoggedIn">
              <button mat-menu-item (click)="navigateToDashboard()">
                <mat-icon svgIcon="view-dashboard"></mat-icon>
                <span>Dashboard</span>
              </button>

              <button mat-menu-item (click)="viewUserProfile()">
                <mat-icon svgIcon="badge-account-horizontal"></mat-icon>
                <span>Profile</span>
              </button>

              <button mat-menu-item (click)="userChangePassword()">
                <mat-icon svgIcon="swap-horizontal"></mat-icon>
                <span>Change Password</span>
              </button>

              <button mat-menu-item (click)="logoutUser()">
                <mat-icon svgIcon="logout"></mat-icon>
                <span>Log out</span>
              </button>
            </ng-container>

            <ng-template #notLoggedIn>
              <button mat-menu-item (click)="navigateToLogin()">
                <mat-icon svgIcon="login"></mat-icon>
                <span>Login</span>
              </button>
            </ng-template>

            <mat-divider></mat-divider>

            <a mat-menu-item
              href="https://forms.zohopublic.com/aviagis/form/MOODPlatformFeedback1/formperma/4krf3GIU4ldg9N9S-ocXpgdRUVLMFcWTahpSaXpDuO0?referrername=platform&email={{userEmail}}&version={{platformVersion}}"
              target="_blank">
              <mat-icon svgIcon="message-draw"></mat-icon>
              <span>Report a bug</span>
            </a>

            <a mat-menu-item href="http://astre-tools.cirad.fr/enquetor/index.php/687991?lang=enW" target="_blank">
              <mat-icon svgIcon="message-draw"></mat-icon>
              <span>Platform and impact survey</span>
            </a>
          </mat-menu>
    </div>
</div>
